import { TextTooltip } from '../text-tooltip';
import { Button } from '../ui/button';
import { InteractCopyIcon, InteractExternalLinkIcon, ViewCheckmarkIcon } from '@/client/assets';
import { useWallet } from '@/client/hooks/use-wallet';
import { formatAddress } from '@/client/utils/format';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

export type WithdrawSubmittedProps = {
  token: string;
  amount: string;
  to: string;
  network: string;
  txHash: string;
  onClose: () => void;
};
export const WithdrawSubmitted = ({ token, amount, to, network, txHash, onClose }: WithdrawSubmittedProps) => {
  const { t } = useTranslation();
  const { chain } = useWallet();
  const handleCopyAddress = useCallback(() => {
    navigator.clipboard.writeText(to);
    toast.success(t('address-copied'));
  }, [to, t]);
  return (
    <div className="space-y-8">
      <div className="px-2 py-3 space-y-3 text-center flex items-center flex-col">
        <ViewCheckmarkIcon className="size-14 fill-beneficial" />
        <h3 className="font-semibold text-xl">{t('submitted')}</h3>
        <p className="text-xs text-foreground/70">{t('est-confirmation-time-1-min')}</p>
      </div>
      <div className=" bg-foreground/5 rounded-3 p-4 space-y-3">
        <div className="flex items-center justify-between text-sm">
          <span className="text-foreground/70">{t('token')}</span>
          <span>{token}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-foreground/70">{t('amount')}</span>
          <span>{amount}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-foreground/70">{t('to')}</span>
          <div className="flex items-center">
            <TextTooltip tooltip={to} show={true}>
              {formatAddress(to)}
            </TextTooltip>
            <InteractCopyIcon
              aria-label={t('copy-address')}
              className="cursor-pointer ml-2 size-4 hover:bg-foreground/5 rounded-md fill-current"
              onClick={handleCopyAddress}
            />
          </div>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-foreground/70">{t('network')}</span>
          <span>{network}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-foreground/70">{t('tx-hash')}</span>
          <div className="flex items-center">
            <TextTooltip tooltip={txHash} show={true}>
              {formatAddress(txHash)}
            </TextTooltip>
            <a href={`${chain?.blockExplorers?.default.url}/tx/${txHash}`} target="_blank">
              <InteractExternalLinkIcon className="cursor-pointer ml-2 size-4 hover:bg-foreground/5 rounded-md fill-current" />
            </a>
          </div>
        </div>
      </div>
      <Button variant="secondary" size="lg" className="w-full" onClick={onClose}>
        {t('ok')}
      </Button>
    </div>
  );
};

export default WithdrawSubmitted;
